import {ImportingDataTypes} from "../../types";
import {createInvalidPartSection, PreventionInvalidityCode} from "./shared";

export const preventativeInteraction = {
    datasourceId: ImportingDataTypes.productVisibilityToOtherPartners,
    sections: [
        createInvalidPartSection(),
        {
            sectionKey: 'invalidPublicToOtherPartners',
            sectionTitle: 'Invalid Public To Other Partners Values',
            invalidityCode: PreventionInvalidityCode.INVALID_BOOLEAN,
            fields: [
                {
                    key: 'partNumber',
                    label: 'Part Number',
                    type: 'text',
                    extractValue: (o) => typeof o === 'string' ? o : o?.partNo ?? null,
                    modifyRow: (row, val) => ({...row, partNumber: val}),
                },
                {
                    key: 'isPublicForBuyers',
                    label: 'Public to other partners',
                    type: 'toggle',
                    modifyRow: (row, val) => ({...row, isPublicForBuyers: val}),
                },
            ],
        },
    ],
};
